import _ from "lodash";
import {SearchArguments, GetIdFromObject} from "@/Repositories/helpers";
import {httpClient} from "@/Repositories/DataGathering/HttpClient";
import {i18n} from "@/i18n";

export class DataGathering{
    /**
     *
     * @param values
     */
    constructor(values) {
        this.academic_period = values.academic_period || {
            id: '',
            title: '',
            description: '',
            current: false,
            order: null,
        };

        this.type = values.type || {
            id: '',
            title: '',
            active: true,
        };

        this.strategy =  values.strategy || {
            id: '',
            title: '',
            active: true,
        };

        this.title = values.title || '';
        this.notes = values.notes || '';
        this.status = values.status || null;
        this.mode = values.mode || null;
        this.created_at = values.created_at || null;
        this.updated_at = values.updated_at || null;
        this.approved_at = values.approved_at || null;

        this.options = values.options || {
            //options for the data store
            data_store: {

            },
            //options for the data_provider
            data_provider: {
                name: null,
            },
            //user related info
            created_by: null,
            approved_by: null,
        };
    }

    /**
     *
     * @param {string} uuid
     * @returns {DataGathering}
     */
    setUuid(uuid) {
        if(typeof uuid === 'string'){
            this.uuid = uuid;
        }

        return this;
    }

    setDataProvider(name, options) {
        const newOptions = this.getOptions();

        newOptions.data_provider = Object.assign(options, {
            name: name,
        });

        this.setOptions(newOptions);

        return this;
    }

    setCreatedBy(user) {
        if(user){
            _.set(this, 'options.created_by', user);
        }

        return this;
    }

    setReplacedBy(user) {
        if(user){
            _.set(this, 'options.replaced_by', user);
        }

        return this;
    }

    removeDataProvider() {
        const newOptions = this.getOptions();

        newOptions.data_provider = {
            name: null,
        };

        this.setOptions(newOptions);
    }

    getOptions() {
        return _.cloneDeep(this.options);
    }

    setOptions(options) {
        this.options = options;

        return this;
    }
}

/**
 * data-gathering read only statuses
 * @type {string[]}
 */
export const readOnlyStatuses = ['created', 'processing', 'closed'];

/**
 * data-gathering resume abbr bible types
 *
 * @type {string[]}
 */
export const bibleResumeAbbr = ['BIBLE_RESUME_MASTER', 'BIBLE_RESUME_GRADE'];

/**
 * data-gathering busy statuses
 *
 * @type {string[]}
 */
export const busyStatuses = ['created', 'processing'];

export default {
    buildSearchArguments(conditions) {
        return new SearchArguments(conditions || {});
    },

    async search(searchArguments) {
        let pagination = _.get(searchArguments, 'pagination', {}),
            sort = _.get(searchArguments, 'sort', []),
            conditions = _.get(searchArguments, 'conditions', {});

        let queryArguments = Object.assign({}, pagination, sort, conditions);

        return httpClient.get(route('data-gatherings.search', queryArguments));
    },

    async get(dataGathering) {
        return httpClient.get(route('data-gatherings.get', {
            id: GetIdFromObject(dataGathering),
        }));
    },

    async store(dataGathering) {
        //@todo, unset auto generation fields

        const bible = (await httpClient.post(route('data-gatherings.store'), dataGathering)).data;

        return new DataGathering(bible);
    },

    async getRecuResume(dataGathering) {
        return httpClient.get(route('data-gatherings.getRecuResume', {
            id: GetIdFromObject(dataGathering),
        }));
    },

    async update(dataGathering) {
        //@todo, unset protected fields {only: [keys], except: [keys]}

        return httpClient.put(route('data-gatherings.update', {
            id: GetIdFromObject(dataGathering),
        }), dataGathering);
    },

    async replace(dataGathering) {
        return httpClient.post(route('data-gatherings.replace', {
            id: GetIdFromObject(dataGathering),
        }), dataGathering);
    },

    async delete(dataGathering) {
        console.log('delete');

        const url = route('data-gatherings.delete', {
            id: GetIdFromObject(dataGathering),
        });

        return httpClient.delete(url, dataGathering);
    },

    //makes a new data gathering instance (util for reference or builder purposes)
    /**
     * @deprecated maybe move to a factory class
     * @param {Object} [values]
     * @returns {DataGathering}
     */
    build(values) {
        return new DataGathering(values || {});
    },

    /**
     * Get all the available statuses
     *
     * @returns {Status[]}
     */
    getStatuses() {
        //in sync with the database enum
        return [
            {
                id: 'created',
                readonly: true,
            },
            {
                id: 'processing',
                readonly: true,
            },
            {
                id: 'pending-revision',
                disabledStatuses: ['processing', 'closed', 'invalid'],
                //roles?
            },
            // {
            //     id: 'ready',
            //     disabledStatuses: ['processing', 'closed', 'invalid'],
            // },
            {
                id: 'invalid',
                disabledStatuses: ['processing', 'closed', 'approved'],
            },
            {
                id: 'approved',
                disabledStatuses: ['processing', 'closed', 'invalid'],
            },
            {
                id: 'closed',
                disabledStatuses: ['processing'],
            },
        ].map(item => new Status(item.id, item));
    }
}

export class Status{
    /**
     *
     * @param id
     * @param options
     */
    constructor(id, options) {
        this.id = id;
        this.name = options.name || i18n.t(`bibles.statuses.${id}`);
        this.title = this.name; //compatibility reasons
        this.readonly = options.readonly || false;
        this.disabled = this.readonly || options.disabled || false;
        this.disabledStatuses = options.disabledStatuses || [];
    }

    /**
     *
     * @param bible
     * @returns {Status}
     */
    setDisabled(bible) {
        if(!bible){
            return this;
        }

        //when is readonly should be always disabled
        if(this.readonly){
            return this;
        }

        //eval user current abilities

        //eval bible current status
        this.disabled = this.disabledStatuses.inArray(bible.status);

        return this;
    }
}
